import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import ValidationText from "../../utils/validation/ValidationText.js";

class QuotationEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isGridView: true,

      filterDetails: {
        partyName: "",
      },

      productDetails: {
        partyName: "",
        productName: "",
        quantity: "",
        packingStyle: "",
        rate: "",
        remarks: "",
      },

      validationRules: {
        productName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "product name"
            ),
          },
        ],
        quantity: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "quantity"
            ),
          },
        ],
        packingStyle: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "packing style"
            ),
          },
        ],
        rate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "rate"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false });
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.productDetails;
    details.partyName = "";
    details.productName = "";
    details.quantity = "";
    details.packingStyle = "";
    details.rate = "";
    details.remarks = "";
    this.setState({ productDetails: details, validState: validState });
  };

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.productDetails;
    details[drpIdentity] = selected.value;
    this.setState({ productDetails: details });
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    if (section === "filterDetails") {
      let details = this.state.filterDetails;
      details[name] = value.toUpperCase();
      this.setState({ filterDetails: details }, () => {
        this.getAllProductionPlanningEntry();
      });
    } else if (section === "productDetails") {
      let details = this.state.productDetails;
      details[name] = value.toUpperCase();
      this.setState({ productDetails: details });
    }
  };

  addEditQuotationEntry = () => {
    let isValidAllFields = this.isValidAllFields();
    // if (isValidAllFields) {
    //   let request = this.state.productDetails;
    //   if (request.productDetialsId === "") {
    //     delete request.productDetialsId;
    //   }
    // }
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.productDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  render() {
    return (
      <div className="quotationEntry-page">
        {/* First page  */}
        {this.state.isGridView === true ? (
          <>
            {/* 1. Item Search  */}
            <div className="item-search">
              <div className="item-grp flex gap-2.5 mb-2.5">
                <div className="search-grp w-3/5">
                  <label>Party Name</label>
                  <input
                    type="text"
                    id="partyName"
                    name="partyName"
                    className="inputFocus w-full"
                    value={this.state.filterDetails.partyName}
                    onChange={(event) =>
                      this.handleChange(event, "partyName", "filterDetails")
                    }
                  />
                </div>
              </div>
              <button className="add-btn" onClick={() => this.closeGridView()}>
                Add
              </button>
            </div>

            {/* 2. Item tabel  */}
            <div className="itemList-table">
              <div className="table-container">
                <table className="itemList">
                  <thead>
                    <tr>
                      <td>Inq. No</td>
                      <td>Date</td>
                      <td>Party Name</td>
                      <td>Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.itemListing && this.state.itemListing.length > 0
                      ? this.state.itemListing.map((item, key) => (
                        <tr key={key}>
                          <td>{item.ItemName}</td>
                          <td>{item.ItemCategory}</td>
                          <td>{item.BasicRate.toFixed(2)}</td>
                          <td>{item.DiscountRate.toFixed(2)}%</td>
                          <td>{item.MinimumQty}</td>
                          <td>{item.MaximumQty}</td>
                          <td>
                            <button
                              className="search-btn"
                            //   onClick={() => this.getItemById(item._id)}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="cancel-btn"
                            //   onClick={() => this.deleteItemById(item._id)}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      ))
                      : null}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : null}

        {/* Second page  */}
        {this.state.isGridView === false ? (
          <div className="item-listing">
            {/* Item Form  */}
            <div className="item-form">
              <div className="form-table !mb-5">
                <div className="item-grp flex gap-2.5 mb-2.5">
                  <div className="search-grp w-3/5">
                    <label>Party Name</label>
                    <MultiSelectDropdown
                      drpIdentity="partyName"
                      //   options={this.state.partyDropdownList}
                      // isMulti
                      // components={{
                      //   Option
                      // }}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={(selected) =>
                        this.setFilterParameters(selected, "partyName")
                      }
                      allowSelectAll={false}
                    // value={this.state.partyDropdownList.find(
                    //   (party) =>
                    //     party.value === this.state.filterDetails.pro
                    // )}
                    />
                  </div>
                </div>
                <hr />

                <div className="item-grp !flex !gap-2.5 mt-2.5">
                  <div className="input-grp w-3/4">
                    <label>Product Name</label>
                    <MultiSelectDropdown
                      drpIdentity="productName"
                      //   options={this.state.productDropdownList}
                      // isMulti
                      // components={{
                      //   Option
                      // }}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={(selected) =>
                        this.setFilterParameters(selected, "productName")
                      }
                      allowSelectAll={false}
                    //   value={this.state.productDropdownList.find(
                    //     (product) =>
                    //       product.value === this.state.filterDetails.pro
                    //   )}
                    />
                    <ValidationText
                      error={this.state.validState.error.productName}
                    />
                  </div>

                  <div className="input-grp w-1/4">
                    <label>Quantity</label>
                    <input
                      type="number"
                      id="quantity"
                      name="quantity"
                      className="inputFocus w-full"
                      value={this.state.productDetails.quantity}
                      onChange={(event) =>
                        this.handleChange(event, "quantity", "productDetails")
                      }
                    />
                    <ValidationText
                      error={this.state.validState.error.quantity}
                    />
                  </div>
                </div>

                <div className="item-grp !flex !gap-2.5 mt-2.5">
                  <div className="input-grp w-3/4">
                    <label>Packing Style</label>
                    <input
                      type="text"
                      id="packingStyle"
                      name="packingStyle"
                      className="inputFocus w-full"
                      value={this.state.productDetails.packingStyle}
                      onChange={(event) =>
                        this.handleChange(
                          event,
                          "packingStyle",
                          "productDetails"
                        )
                      }
                    />
                    <ValidationText
                      error={this.state.validState.error.packingStyle}
                    />
                  </div>

                  <div className="input-grp w-1/4">
                    <label>Rate</label>
                    <input
                      type="number"
                      id="rate"
                      name="rate"
                      className="inputFocus w-full"
                      value={this.state.productDetails.rate}
                      onChange={(event) =>
                        this.handleChange(event, "rate", "productDetails")
                      }
                    />
                    <ValidationText error={this.state.validState.error.rate} />
                  </div>
                </div>

                <div className="item-grp mt-2.5">
                  <div className="input-grp w-full">
                    <label>Remarks</label>
                    <input
                      type="text"
                      id="remarks"
                      name="remarks"
                      className="inputFocus w-full"
                      value={this.state.productDetails.remarks}
                      onChange={(event) =>
                        this.handleChange(event, "remarks", "productDetails")
                      }
                    />
                  </div>
                </div>

                <div className="btn-grp flex gap-2.5 mt-4">
                  {this.state.isEditing === true ? (
                    <button
                      className="add-btn"
                    //  onClick={() => this.addEditItems()}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="add-btn"
                      onClick={() => this.addEditQuotationEntry()}
                    >
                      Add
                    </button>
                  )}
                  <button
                    className="cancel-btn"
                    onClick={() => this.openGridView()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            {/* Item tabel  */}
            <div className="itemList-table">
              <div className="table-container">
                <table className="itemList">
                  <thead>
                    <tr>
                      <td>Product Name</td>
                      <td>Quantity</td>
                      <td>Packing Style</td>
                      <td>Rate</td>
                      <td>Remarks</td>
                      <td>Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.itemListing && this.state.itemListing.length > 0
                      ? this.state.itemListing.map((item, key) => (
                        <tr key={key}>
                          <td>{item.ItemName}</td>
                          <td>{item.ItemCategory}</td>
                          <td>{item.BasicRate.toFixed(2)}</td>
                          <td>{item.DiscountRate.toFixed(2)}%</td>
                          <td>{item.MinimumQty}</td>
                          <td>{item.MaximumQty}</td>
                          <td>
                            <button
                              className="search-btn"
                            //   onClick={() => this.getItemById(item._id)}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="cancel-btn"
                            //   onClick={() => this.deleteItemById(item._id)}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      ))
                      : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default QuotationEntry;
